<dialog
    #dialog
    class="drawer"
    [class.drawer--wide]="wide"
    [class.drawer--modal]="variant === 'modal'"
    [attr.aria-label]="label"
    (keydown.escape)="OnEscape($event)"
    (click)="OnBackdropClick($event)">
    <div class="frame">
        <header class="head" [class.head--navy]="headerStyle === 'navy'">
            <div class="head-content">
                <ng-content select="[drawerTitle]"></ng-content>
            </div>
            <button type="button" class="close" aria-label="Close" (click)="Close()">
                <svg viewBox="0 0 20 20" aria-hidden="true">
                    <path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
                </svg>
            </button>
        </header>
        <div class="body">
            <ng-content></ng-content>
        </div>
        <footer class="foot">
            <ng-content select="[drawerFooter]"></ng-content>
        </footer>
    </div>
</dialog>
